import { call, put, select } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '../../APIs/common/service-locator';
import { setSsapSettings } from '../../actions/ssap/ssapActionCreators';
import { getIsState } from '../../reducers/appReducer';
import { ENABLED, DISABLED } from '../../constants/ssap/miscellaneous/miscellaneous';

export function* ssapSettingsSaga(...args) {
    const [ replacements ] = args;
    const isState = yield select(getIsState);
    const ssapService = yield call(serviceLocator, SSAP_SVC);
    const settings = yield call([ssapService, ssapService.getSettings], replacements);
    if(settings) {
        // All mixins are artificial ones until decision is made:
        // - to pass such settings from backend depends on configuration OR
        // - remove them and their usages;

        // Mixins go first in settings to have possibility to override them by backend
        const mixins = {
            itfFeature: isState.PA ? ENABLED : DISABLED,
            inlineCurrentIncomeEnabled: ENABLED,
            inlineEligibilityIgnoredForEscPage: ENABLED
        };

        yield put(setSsapSettings({ ...mixins, ...settings }));
    } else {
        yield call(global.console.log, 'SSAP settings are not retrieved');
    }
}